import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import FullPageLoader from '../components/FullPageLoader';
import useAuth from '../hooks/useAuth';
import { resolveRedirectPath } from './authRedirect';

const PublicRoute: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <FullPageLoader message="Carregando sua sessao..." />;
  }

  if (isAuthenticated) {
    return <Navigate to={resolveRedirectPath(location.search)} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
